<template>
  <b-modal
    id="modificarEmpresaModal"
    size="xl"
    title="Modificar empresa"
    :hide-footer="true"
    @hidden="borrarModal"
    @shown="onShown"
  >
    <form @submit.prevent="submit" v-promise-btn="{ action: 'submit' }">
      <card-item>
        <template>
          <div class="d-flex justify-content-center align-items-center">
            <h4 class="card-title">Modificar Empresa</h4>
          </div>
        </template>
        <div class="container">
          <div class="row" v-if="this.empresa">
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label for="RazonSocial" class="label">Razón social </label>
              <input
                type="text"
                :class="`form-control form-control-sm text-center bg-white${
                  !isRazonSocialOk && isDirty ? ' is-invalid' : ''
                }`"
                style="cursor: text"
                v-model="RazonSocial"
                id="RazonSocial"
              />
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label for="CUIT" class="label">CUIT</label>
              <the-mask
                :mask="['##-########-#']"
                type="text"
                :class="`form-control form-control-sm text-center bg-white${
                  !isCUITOk && isDirty ? ' is-invalid' : ''
                } 
                 ${CUIT.replace(/[^0-9]/g, '').length === 11 ? (isCUITValid ? 'is-valid' : 'is-invalid') : ''} 
                 `"
                style="cursor: text"
                v-model="CUIT"
                id="CUIT"
              />
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label for="CondicionFrenteAlIVA" class="label"
                >Condicion IVA</label
              >
              <select
                v-model="CondicionFrenteAlIVA"
                :class="`form-control form-control-sm text-center bg-white${
                  !isCondicionIVA && isDirty ? ' is-invalid' : ''
                }`"
                id="CondicionFrenteAlIVA"
              >
                <option value="null">-</option>
                <option value="Responsable Inscripto">
                  Responsable Inscripto(Factura A)
                </option>
                <option value="Excento">Excento (Factura B)</option>
                <option value="Monotributo">Monotributo(Factura C)</option>
              </select>
            </div>

            <div class="col-12 col-md-6 form-group form-group-sm">
              <label for="alicuotaIVA" class="label">Alícuota IVA</label>
              <input
                type="text"
                :class="`form-control form-control-sm text-center bg-white ${!isAlicuotaIVAOK && isDirty ? 'is-invalid' : ''}`"
                style="cursor: text"
                v-model="AlicuotaIVA"
                id="alicuotaIVA"
              />
            </div>
            <div class="col-12 form-group form-group-sm">
              <label for="DomicilioComercial" class="label"
                >Domicilio Comercial</label
              >
              <input
                type="text"
                :class="`form-control form-control-sm text-center bg-white${
                  !isDomicilioComercialOk && isDirty ? ' is-invalid' : ''
                }`"
                style="cursor: text"
                v-model="DomicilioComercial"
                id="DomicilioComercial"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  @click="cancelarModal"
                  type="button"
                  class="btn btn-secondary"
                >
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary">Aceptar</button>
              </div>
            </div>
          </div>
        </div>
      </card-item>
    </form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "ModificarEmpresa",
  data: () => ({
    isDirty: false,
    id_cliente: "",
    CUIT: "",
    RazonSocial: "",
    CondicionFrenteAlIVA: "",
    FechaInicioActividades: "",
    DomicilioComercial: "",
    AlicuotaIVA: "",
  }),
  computed: {
    empresa() {
      return this.$store.state.Empresas.empresaForUpdate;
    },
    isRazonSocialOk() {
      return true;
    },
    isDomicilioComercialOk() {
      return true;
    },
    isCUITOk() {
      return (
        this.CUIT !== "" &&
        (this.CUIT.replace(/[^0-9]/g, "").length !== 11 || this.isCUITValid)
      );
    },
    isCondicionIVA() {
      return true;
    },
    isAlicuotaIVAOK() {
      return true;
    },
    isFormOk() {
      return (
        this.isRazonSocialOk &&
        this.isDomicilioComercialOk &&
        this.isCUITOk &&
        this.isAlicuotaIVAOK &&
        this.isCondicionIVA
      );
    },
    isCUITValid() {
      const validCuit = this.CUIT.replace(/[^0-9]/g, "");
      return validCuit.length === 11 && this.cuilValidador(validCuit);
    },
  },
  methods: {
    cuilValidador(cuil) {
      if (cuil.length !== 11) {
        return false;
      }

      const [checkDigit, ...rest] = cuil.split("").map(Number).reverse();

      const total = rest.reduce(
        (acc, cur, index) => acc + cur * (2 + (index % 6)),
        0,
      );

      const mod11 = 11 - (total % 11);

      if (mod11 === 11) {
        return checkDigit === 0;
      }

      if (mod11 === 10) {
        return false;
      }

      return checkDigit === mod11;
    },
    borrarModal() {
      this.$bvModal.hide("modificarEmpresaModal");
    },
    onShown() {
      this.isDirty = false;
      this.id_cliente = this.empresa.id_cliente;
      this.CUIT = this.empresa.CUIT;
      this.RazonSocial = this.empresa.RazonSocial;
      this.CondicionFrenteAlIVA = this.empresa.CondicionFrenteAlIVA;
      this.AlicuotaIVA = this.empresa.AlicuotaIVA;

      this.DomicilioComercial = this.empresa.DomicilioComercial;
    },
    async submit() {
      this.isDirty = true;
      if (!this.isCUITValid) {
        this.$msgBoxOk("Por favor, complete correctamente el CUIT");
        return;
      }
      if (this.isFormOk) {
        const resp = await axios.post("/execute", {
          method: "CLI.ModificarEmpresa",
          parameters: [
            { name: "id_empresa", value: this.empresa.id_empresa },
            { name: "id_cliente", value: this.empresa.id_cliente },
            { name: "cuit", value: this.CUIT },
            { name: "razon_social", value: this.RazonSocial },
            {
              name: "condicion_frente_al_IVA",
              value: this.CondicionFrenteAlIVA,
            },
            { name: "domicilio_comercial", value: this.DomicilioComercial },
            { name: "AlicuotaIVA", value: this.AlicuotaIVA },
          ],
        });
        if (resp.data.ok) {
          this.$bvModal.hide("modificarEmpresaModal");
          this.$store.dispatch("Empresas/getEmpresas", this.id_cliente);
          this.$bvToast.toast(resp.data.message, {
            variant: "success",
          });
        } else {
          this.$bvToast.toast(resp.data.message, {
            variant: "error",
          });
        }
      }
    },
    cancelarModal() {
      this.$bvModal.hide("modificarEmpresaModal");
    },
  },
};
</script>

<style scoped></style>
